"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reduxForm = require("redux-form");
var _reactRedux = require("react-redux");
var _userActions = require("../../redux/actions/userActions");
var ResetPasswordRequestFormContainerFactory = function ResetPasswordRequestFormContainerFactory(Component) {
  var ResetPasswordRequestFormContainer = (0, _reduxForm.reduxForm)({
    form: 'resetPasswordRequest',
    destroyOnUnmount: false,
    onSubmit: function onSubmit(payload, dispatch) {
      return dispatch((0, _userActions.submitResetPasswordForm)(payload));
    }
  })(Component);
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResetPasswordRequestFormContainer);
};
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form;
  return {
    formObj: form.resetPasswordRequest ? form.resetPasswordRequest.values : {}
  };
};
var mapDispatchToProps = {
  goToStep: _userActions.goToResetPasswordFormStep
};
var _default = exports["default"] = ResetPasswordRequestFormContainerFactory;